"use client";

import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { CallAnalysisOverviewPoint } from "@/app/types/call/CallAnalysisOverview";
import { CHART_AXIS_LINE, CHART_AXIS_TICK, formatDay } from "../AnalysisOverview.logic";
import overviewStyles from "../AnalysisOverview.module.css";
import TimelineTooltip from "../TimelineTooltip";
import styles from "./ScoreTimeline.module.css";

type Props = {
  timeline: CallAnalysisOverviewPoint[];
  compact?: boolean;
};

export default function ScoreTimeline(props: Props) {
  const T = useT();
  const { timeline, compact = false } = props;

  return (
    <div className={overviewStyles.card}>
      <span className={overviewStyles.cardTitle}>{T(TKey.CALL_OVERVIEW_TIMELINE_TITLE)}</span>

      <div className={compact ? styles.chartCompact : styles.chart}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={timeline} margin={{ top: 8, right: 8, bottom: 0, left: -22 }}>
            <defs>
              <linearGradient id="overviewScore" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" className={styles.scoreGradient} stopOpacity={0.18} />
                <stop offset="100%" className={styles.scoreGradient} stopOpacity={0} />
              </linearGradient>
            </defs>

            <CartesianGrid vertical={false} />

            <XAxis
              dataKey="label"
              tickFormatter={formatDay}
              tick={CHART_AXIS_TICK}
              tickLine={false}
              axisLine={CHART_AXIS_LINE}
              interval="preserveStartEnd"
            />
            <YAxis domain={[0, 100]} tick={CHART_AXIS_TICK} tickLine={false} axisLine={false} />

            <Tooltip content={TimelineTooltip} />

            <Area
              type="monotone"
              dataKey="score"
              name={T(TKey.CALL_OVERVIEW_KPI_SCORE) as string}
              className={styles.scoreLine}
              strokeWidth={2}
              fill="url(#overviewScore)"
              dot={{ r: 3, className: styles.scoreDot, strokeWidth: 0 }}
              activeDot={{ r: 6, className: styles.scoreDot }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
